import React from 'react';
import { useField } from 'informed';

import { CheckboxGroup, CheckboxGroupItem } from '@nw/omega-design-system';

import { FieldContainer } from './styledComponents';

interface InformedOmegaCheckboxGroupFieldProps {
  options: any;
  label: string;
  placeholder: string;
  field: string;
  error: string;
  touched: boolean;
  validationSchemaObject: any;
  isHidden?: boolean;
  fieldWrapperStyles?: boolean;
  checkBoxGroupItemLabelClassName?: string;
  labelClassName?: string;

  fieldContainerClassName?: string;
}

export const InformedOmegaCheckboxGroupField = (
  props: InformedOmegaCheckboxGroupFieldProps
) => {
  const {
    options,
    label,
    placeholder,
    field,
    error,
    touched,
    validationSchemaObject,
    isHidden,
    fieldWrapperStyles,
    labelClassName,
    checkBoxGroupItemLabelClassName,
    fieldContainerClassName
  } = props;

  //@ts-ignore
  const { fieldState, render, informed, fieldApi } = useField({
    field,
    validateOnBlur: true,
    validateOnChange: true,
    //@ts-ignore
    validationSchema: validationSchemaObject.fields[field],
    error: error,
    touched: touched
  });

  const { onChange } = informed;
  const { setValue } = fieldApi;

  const onSelectionChange = (value) => {
    onChange(value);
    setValue(value);
  };

  const renderOmegaCheckboxGroupField = () => (
    <CheckboxGroup
      label={label}
      onChange={onSelectionChange}
      errorMessage={error}
      labelClassName={labelClassName}
    >
      {options &&
        options.map((option) => (
          <CheckboxGroupItem
            labelClassName={checkBoxGroupItemLabelClassName}
            value={option}
          >
            {option.label}
          </CheckboxGroupItem>
        ))}
    </CheckboxGroup>
  );

  return (
    <FieldContainer
      key={field}
      isHidden={isHidden}
      css={fieldWrapperStyles}
      className={fieldContainerClassName}
    >
      {renderOmegaCheckboxGroupField()}
    </FieldContainer>
  );
};
